module.exports = __webpack_public_path__ + "static/system-design-interview-03ba91f4f457befc53f3e8054bea45af.jpeg";